<div [ngClass]="{ divider: true, 'divider--loose': loose }">
  <span class="divider__label">
    <ng-content />
  </span>
</div>
